module.exports = __webpack_public_path__ + "img/usjt-branco.678b37d6.svg";